import React, { useEffect, useState } from "react";
import Checklist from "lib/components/Checklist";
import withLanguageContext from "lib/hocs/withLanguageContext";
import withNotifier from "lib/hocs/withNotifier";
import SnackbarAlert from "Components/Fragment/SnackbarAlert";
import styled, { createGlobalStyle } from "styled-components";

const StylePageChecklistAdmin = createGlobalStyle`
 
  body div.movablemodal-body {
    top: 50px !important;
  }

  table.maindatatable {
    border-radius: 0;
    box-shadow: none;
  }
  
`;

const StyledChecklistAdmin = styled.div`
  padding-top: 10px;
`;

const ChecklistAdmin = (props) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    setOpenSnackbar(props.notification.visible);
  }, [props.notification.visible]);

  const handleClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <StylePageChecklistAdmin />
      <StyledChecklistAdmin>
        <Checklist
          id={props.activityId}
          languageContext={props.languageContext}
          onNotification={props.notification.onNotification}
          className="bgColor-6"
          lang={props.lang}
        >
          {(checklistState, checklistActions) => {
            const {
              onNewItem,
              onAddItem,
              onUpdateItem,
              onSelectItem,
              onCopy,
              onCopyChecklist,
              onDeleteItems,
              onReset,
              onValidation,
              checklistItems_actions,
            } = checklistActions;
            const {
              checklist,
              activitiesToCopyFrom,
              activeItem,
              selectedItems,
              languageContext,
              displayItem,
              displayCopy,
              displayReminder,
            } = checklistState;
            const toasStyle = { marginLeft: "290px" };

            return (
              <>
                {!checklistState.displayItem && (
                  <Checklist.Header
                    languageContext={languageContext}
                    onAdd={onNewItem}
                    onCopy={onCopy}
                    onDelete={onDeleteItems}
                    showCopy={checklistState.activitiesToCopyFrom.length > 0}
                    showDelete={checklist.tasks.length > 0}
                    showButtonIcons={false}
                  />
                )}
                <br />
                {!displayItem && (
                  <Checklist.TableAdmin
                    languageContext={languageContext}
                    actions={checklistActions}
                    list={checklist.tasks}
                    selectedItems={selectedItems}
                    activitiesToCopyFrom={checklistState.activitiesToCopyFrom}
                  />
                )}
                {displayItem && (
                  <Checklist.Item
                    languageContext={languageContext}
                    item={activeItem}
                    onSave={
                      activeItem.checklistItemID ? onUpdateItem : onAddItem
                    }
                    onCancel={onReset}
                    actions={checklistActions}
                    editable
                    onValidation={onValidation}
                    maxHeight="1000px"
                    lang={props.lang}
                  />
                )}
                {displayCopy && (
                  <Checklist.Copy
                    languageContext={languageContext}
                    onCancel={onReset}
                    onCopyChecklist={onCopyChecklist}
                    activitiesToCopyFrom={activitiesToCopyFrom}
                  />
                )}
                {displayReminder && (
                  <Checklist.Reminder
                    languageContext={languageContext}
                    onCancel={onReset}
                  />
                )}
                {props.notification && (
                  <SnackbarAlert
                    open={openSnackbar}
                    message={props.notification.message}
                    onClose={handleClose}
                  />
                )}
              </>
            );
          }}
        </Checklist>
      </StyledChecklistAdmin>
    </>
  );
};

export default withLanguageContext(withNotifier(ChecklistAdmin), "Checklists");
